export default function initMenu() {
    document.querySelector('[data-hamburger-menu-btn]').addEventListener('click', (event) => {
        const mainMenu = document.querySelector('[data-main-menu]');
        mainMenu.classList.toggle('hidden');

        const hamburgerMenuButton = document.querySelector('[data-hamburger-menu-btn]');
        if (hamburgerMenuButton.getAttribute('aria-expanded') === 'false') {
            hamburgerMenuButton.setAttribute('aria-expanded', 'true');
        } else {
            hamburgerMenuButton.setAttribute('aria-expanded', 'false');
        }

        const hamburgerMenuIcon = document.querySelector('[data-hamburger-menu-icon]');
        hamburgerMenuIcon.classList.toggle('hidden');

        const closeMenuIcon = document.querySelector('[data-close-menu-icon]');
        closeMenuIcon.classList.toggle('hidden');
    });

    // Toggle sub menu also by keyboard
    const menuItemWithChildren = document.querySelector('.menu-item-with-children');
    menuItemWithChildren.onkeydown = function (e) {
        if (e.key === 'Enter') {
            e.currentTarget.classList.toggle('menu-item-with-children-triggered');
        }
    };
}
